import { NgClass } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  BadgeComponent,
  ButtonComponent,
  IconButtonComponent,
  IconColorDirective,
  IconComponent,
} from '@core/user-interface-legacy';

import type { ArrowPosition, ArrowType, WalkthroughComponentProperties } from '../../types';

@Component({
  selector: 'rt-walkthrough-tooltip',
  imports: [
    ButtonComponent,
    NgClass,
    IconButtonComponent,
    IconColorDirective,
    IconComponent,
    BadgeComponent,
    TranslatePipe,
  ],
  templateUrl: './walkthrough-tooltip.component.html',
  styleUrl: './walkthrough-tooltip.component.less',
})
export class WalkthroughTooltipComponent implements WalkthroughComponentProperties {
  public i18n = inject(I18nService);

  @Input() public arrowConfig: [ArrowPosition, ArrowType] = ['middle', 'left'];

  @Input() public currentStep: number;
  @Input() public stepsTotal: number;
  @Input() public showStepCounter: boolean = true;
  @Input() public hasNewBadge: boolean = false;

  @Input() public heading: string;
  @Input() public description: string;

  @Input() public ofText: string = this.i18n.translate('app.common.of');
  @Input() public ctaText: string;
  @Input() public ctaIcon?: IconName = undefined;

  @Output()
  public cancel = new EventEmitter<void>();
  public finish = new EventEmitter<void>();
  public next = new EventEmitter<void>();

  public closeTooltip() {
    this.cancel.emit();
  }
}
